import { render, staticRenderFns } from "./AsideTag.vue?vue&type=template&id=2b0eb451&scoped=true"
import script from "./AsideTag.vue?vue&type=script&lang=js"
export * from "./AsideTag.vue?vue&type=script&lang=js"
import style0 from "./AsideTag.vue?vue&type=style&index=0&id=2b0eb451&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0eb451",
  null
  
)

export default component.exports